import { useTranslation } from "react-i18next";
import GlobalLoader from "./GlobalLoader";

export default function LoadingSpinner() {
  const { t } = useTranslation();

  return <GlobalLoader message={t("groups.cargando")} />;
}
